import type { IconData } from '@stacksjs/iconify-core'

export const menu: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M649 94H0V1h649zm0 231H0v-92h649zm0 232H0v-93h649z\"/>",
  "width": 650,
  "height": 750,
  "viewBox": "0 0 650 750"
}

export default menu
